import template from './new.html';
import controller from './new.controller';

const newMessageComponent = {
  restrict: 'E',
  controller,
  template
};

export default newMessageComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/messageOutbound/new/new.component.js
 **/